import bulldozer from '../images/tractors/general yellow bulldozer.png'
import commercial_truck from '../images/trucks/Peterbilt 589 Legendary.jpg'

export const stockIntro = [
    {
        title: 'Tractors',
        image: bulldozer,
    },

    {
        title: 'Trucks',
        image: commercial_truck,
    },
]